import slugify from 'slugify';

export function slugIt(value: string): string {
  return slugify(value, { remove: /[^\w\s-]/g, replacement: '-', lower: true });
}
